<template>
  <el-dialog
    :title="$t('OrderPage[\'Claim a free gift\']')"
    v-model="dialogVisible"
    class="express-checkout-patient-address-ppl order-test"
    :close-on-click-modal="true"
    @close="close"
    > 
    <div class="flex justify-center">
      <img src="@/assets/orderTest/order-page/dialog/freeAddOnGift.svg">
    </div>
    <div class="mt-4">
      <div
        v-for="opt in options"
        :key="opt.id"
        class="free-addon-test-card flex items-center px-3 mb-3 cursor-pointer"
        :class="{ selected: selectedIds.includes(opt.id) }"
        role="checkbox"
        :aria-checked="selectedIds.includes(opt.id)"
        tabindex="0"
        @click="toggleSelect(opt.id)"
        @keydown.enter.prevent="toggleSelect(opt.id)"
        @keydown.space.prevent="toggleSelect(opt.id)"
      >
        <img
          :src="selectedIds.includes(opt.id) ? checkboxIcons.allCheck : checkboxIcons.unCheck"
          alt="select"
          class="checkbox-icon"
        />
        <span class="inform-text ml-3 addon-text">
          {{ opt.label || opt.name || ('Item #' + opt.id) }}
        </span>
      </div>
    </div>

    <template v-slot:footer>
    <span class="flex justify-end">
      <button class="no-btn" @click="close('pass')">{{ $t("OrderPage[\"I’ll pass\"]") }}</button>
      <button 
        class="yes-btn" 
        :disabled="selectedIds.length === 0" 
        @click="close('addForFree')"
      >{{ $t("OrderPage[\"Yes, add it for free\"]") }}</button>
    </span>
    </template>
  </el-dialog>
</template>

<script>
import { updatePatientApi } from "@/api/va-order-page/orderTest.js";

export default {
  props: {
    isShowDialog: {
      type: Boolean,
      default: true,
    },
    isSelectedTaxableTest: {
      type: Array,
      default: () => []
    },
    options: { 
      type: Array, 
      default: () => [] 
    },
  },
  data() {
    return {
      dialogVisible: false,
      isIntrestPopup: false,
      selectedIds: [],
      checkboxIcons: {
        unCheck: require('@/assets/orderTest/check_box_outline_blank_24px.svg'),
        allCheck: require('@/assets/orderTest/Checkbox(all).svg')
      }
    };
  },

  watch: {
    isShowDialog(newVal) {
      this.dialogVisible = newVal;
      this.selectedIds = newVal ? this.options.map(o=>o.id) : []
    },
  },
  methods: {
    close(action) {
      if(action==="pass") {
        this.$emit("close");
      }
      else if(action === 'addForFree' && this.selectedIds.length > 0) {
        this.selectedIds.forEach(id => {
          this.$store.dispatch("orderTest/addSelectedTest", { id: Number(id) });
        });
        this.$emit("close");
      }
    },
    toggleSelect(id) {
      const idx = this.selectedIds.indexOf(id);
      if (idx === -1) {
        this.selectedIds = [...this.selectedIds, id];
      } else {
        const copy = [...this.selectedIds];
        copy.splice(idx, 1);
        this.selectedIds = copy;
      }
    }
  }
}
</script>

<style scoped>
.inform-text {
  color: #000;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

/* .country-input-box {
  width: 150px;
  border-radius: 5px;
  border: 1px solid var(--base-black, #424242);
  background: #FFF;
  margin-right: 24px;
}

.address-input-box {
  width: 324px;
  border-radius: 5px;
  border: 1px solid var(--base-black, #424242);
  background: #FFF;
}

.input-title {
  display: flex;
  padding: 5px 10px;
} */

.no-btn{
  height: 42px;
  background: #E6E6E6;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 26px;
  letter-spacing: 0.429px;
  color: #000000;
  margin-right: 17px;
  border-radius: 4px;
  padding: 8px 20px;
}

.yes-btn{
  height: 42px;
  background: #20A8C3;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 26px;
  letter-spacing: 0.429px;
  color: #FFFFFF;
  border-radius: 4px;
  padding: 8px 20px;
}
.yes-btn:disabled {
  background: #E6E6E6;
  color: #A0A0A0;
  cursor: not-allowed;
}

.span-icon {
  color: #F00;
  /* font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal; */
}

.line {
  border-bottom: 1px solid #E6E6E6;
}

.title {
  color: var(--Base-Black, #000);
  font-family: Roboto;
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 133.333% */
  letter-spacing: 0.15px;
}

.free-addon-test-card {
  min-height: 46px;
  background: #F9FBFD;
  box-shadow: 0 2px 6px rgba(48, 48, 48, 0.13);
  border-radius: 3.2px;
  transition: background-color .15s;
}
.free-addon-test-card.selected {
  background: #F9FBFD;
}
.checkbox-icon {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}
.addon-text {
  flex: 1;
  white-space: normal;
  word-break: break-word;
}
</style>